
export default {
	props: ['label', 'disabled','md','placeholder','condensed','tag','old_value','tooltip','p_icon','a_icon','view_only','offset','optional'],
	computed:{
		c_placeholder() { return this.placeholder || (this.label ? ` Ingrese ${this.label}` : '') },
		c_tag(){ return this.tag || (this.md?'v-flex':'div') },
	},
};
